<script setup lang="ts">
import '@kidzonet/common-styles/poppins-font.css'
import '@kidzonet/common-styles/reset.css'
import '@kidzonet/common-styles/themeVariables.css'

import Content from './Content.vue'
</script>

<template>
    <v-app>
        <Suspense>
            <Content />
        </Suspense>
    </v-app>
</template>
